// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"101":"240cf19f","178":"598f782c","221":"194d3901","400":"c1edf310","560":"2f2c64a4","616":"685ff56d","775":"858a5232","936":"1807d042","963":"7fc7e18c"}[chunkId] + ".chunk.js";
};